/**
 * Parse location to params
 * @param search
 * @returns {{}}
 */

export default function parseLocation(search) {
  const a = (search[0] === '?' ? search.substr(1) : search).split('&');
  const query = {};

  for (let i = 0; i < a.length; i += 1) {
    const b = a[i].split('=');
    query[decodeURIComponent(b[0])] = decodeURIComponent(b[1] || '');
  }

  return query;
}



// WEBPACK FOOTER //
// ./utils/parseLocation.js